"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDictData = exports.deleteDictDataById = exports.deleteBatchDictDataById = exports.addDictData = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加字典数据表
 * @param dictData
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addDictData = exports.addDictData = function addDictData(dictData) {
  return _api.default.request({
    url: '/system/dict-data/save',
    method: 'post',
    data: dictData
  });
};

/**
 * 修改字典数据表
 * @param dictData
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateDictData = exports.updateDictData = function updateDictData(dictData) {
  return _api.default.request({
    url: '/system/dict-data/update',
    method: 'post',
    data: dictData
  });
};

/**
 * 删除字典数据表
 * @param dictDataId
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteDictDataById = exports.deleteDictDataById = function deleteDictDataById(dictDataId) {
  return _api.default.request({
    url: '/system/dict-data/delete',
    method: 'post',
    params: {
      id: dictDataId
    }
  });
};

/**
 * 批量删除字典数据表
 * @param dictDataIds
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchDictDataById = exports.deleteBatchDictDataById = function deleteBatchDictDataById(dictDataIds) {
  return _api.default.request({
    url: '/system/dict-data/deleteBatch',
    method: 'post',
    data: dictDataIds
  });
};